import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import Grid from "@material-ui/core/Grid";
import SearchSq from "Component/Material-ui/SearchSq";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import get from "lodash/get";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emp360 from "Assets/Svg/emp360.svg";
import { CheckActionPermission } from "Actions/commonAction";
import emptylist from "../../../../../../Assets/Svg/illustration-no-policy.svg";
import { instance } from "../../../../../../Actions/AxiosInstance";
import If from "../../../../../../Component/Common/If";
import CustomLoader from "Component/CustomLoader";

import {
  List,
  TDTypeConsts,
  CreateComp,
} from "../../../../business-configration/commons";
import Create from "./create";

const tempparticipant = [
  {
    // feedbacksettingsid: 1,
    participantdayid: null,
    participanttypeid: 1,
    openday: null,
    frequencytypeid: null,
    closeday: null,
    isprimarymanager: false,
    issecondarymanager: false,
    ismanagersmanager: false,
    issecondarymanagerreportee: false,
    issharefeedback: false,
    isfeedbackanonymous: false,
    isviewduring: false,
    isviewafter: false,
    isSelected: false,
    isemppeerdecide:false,
  },
  {
    // feedbacksettingsid: 1,
    participantdayid: null,
    participanttypeid: 2,
    openday: null,
    frequencytypeid: null,
    closeday: null,
    isprimarymanager: true,
    issecondarymanager: false,
    ismanagersmanager: false,
    issecondarymanagerreportee: false,
    issharefeedback: false,
    isfeedbackanonymous: false,
    isviewduring: false,
    isviewafter: false,
    isSelected: false,
    isemppeerdecide:false,
  },
  {
    // feedbacksettingsid: 1,
    participantdayid: null,
    participanttypeid: 3,
    openday: null,
    frequencytypeid: null,
    closeday: null,
    isprimarymanager: false,
    issecondarymanager: false,
    ismanagersmanager: false,
    issecondarymanagerreportee: false,
    issharefeedback: false,
    isfeedbackanonymous: false,
    isviewduring: false,
    isviewafter: false,
    isSelected: false,
    isemppeerdecide:false,
  },
  {
    // feedbacksettingsid: 1,
    participantdayid: null,
    participanttypeid: 4,
    openday: null,
    frequencytypeid: null,
    closeday: null,
    isprimarymanager: false,
    issecondarymanager: false,
    ismanagersmanager: false,
    issecondarymanagerreportee: false,
    issharefeedback: false,
    isfeedbackanonymous: false,
    isviewduring: false,
    isviewafter: false,
    isSelected: false,
    isemppeerdecide:false,
  },
];
const tempdata = JSON.stringify(tempparticipant);

let CALLAPI = true;
class ReviewStructure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: 1,
      monthArray: [
        { id: "1", name: "Jan" },
        { id: "2", name: "Feb" },
        { id: "3", name: "Mar" },
        { id: "4", name: "Apr" },
        { id: "5", name: "May" },
        { id: "6", name: "Jun" },
        { id: "7", name: "Jul" },
        { id: "8", name: "Aug" },
        { id: "9", name: "Sep" },
        { id: "10", name: "Oct" },
        { id: "11", name: "Nov" },
        { id: "12", name: "Dec" },
      ],
      permissions: { editable: true, readonly: true },
      listdata: [],
      offset: 0,
      createmenu: false,
      searchReviewValue: null,
      backuplistdata: [],
      limit: 10,
      value: 0,
      right: false,
      linkeddetails: [],
      draweropen: false,
      data: false,
      isViewDetails: false,
      selectedReview: null,
      copypolicy: null,
      nofuel: false,
      selectedRow: null,
      fullcount: 1,
      headers: [
        {
          key: "structurename",
          name: "Structure name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "reviewperiod",
          name: "Review period",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "imagepath",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "noofform",
          name: "Linked forms",
          type: TDTypeConsts.LINKED_USER,
        },
        {
          key: "moreoptions",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getReviewStructure = this.getReviewStructure.bind(this);
    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.getPerformanceCycle = this.getPerformanceCycle.bind(this);
    this.__renderLinkedUser = this.__renderLinkedUser.bind(this);
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "isViewDetails") {
      this.setState({
        isViewDetails: true,
        draweropen: true,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        draweropen: false,
        right: false,
        isViewDetails: false,
      });
    }
  };

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  getPerformanceCycle() {
    const { monthArray } = this.state;
    instance
      .get("/perform/getperformcycle")
      .then((result) => {
        if (result.data.result.length > 0) {
          console.log("result.data.result: ", result.data.result);
          const newMonthArray = [];
          monthArray.forEach((month) => {
            newMonthArray.push(month);
          });
          let monthNumber = result.data.result[0].cycleid - 1;
          while (monthNumber--) {
            const temp = newMonthArray.shift();
            newMonthArray.push(temp);
          }
          this.setState({
            monthArray: newMonthArray,
          });
        } else {
          this.props.enqueueSnackbar(
            "Please configure performance cycle first",
            { variant: "error" },
          );
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  closeDrawer() {
    this.setState({
      selectedUser: null,
      right: false,
      draweropen: false,
      isViewDetails: false,
    });
  }

  handleStructureSearch = (e) => {
    const { backuplistdata } = this.state;
    const filterFormList = backuplistdata.filter(
      (item) => item.structurename.toLowerCase().search(e.target.value) !== -1,
    );
    this.setState({
      searchReviewValue: e.target.value,
      listdata: e.target.value ? filterFormList : backuplistdata,
    });
  };

  // handleScroll() {
  //   const windowBottom =
  //     Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
  //   if (windowBottom + 50 >= Math.floor(window.innerHeight * 0.65)) {
  //     if (shouldCallAPI) {
  //       if (this.state.fullcount > this.state.offset) {
  //         shouldCallAPI = false;
  //         this.setState(
  //           {
  //             offset: this.state.offset + 10,
  //           },
  //           () => this.getReviewStructure(),
  //         );
  //         setTimeout(() => {
  //           shouldCallAPI = true;
  //         }, 5000);
  //       } else {
  //         this.setState({
  //           message: "no data",
  //         });
  //       }
  //     }
  //   }
  // }

  handleScroll() {
    console.log("dsfds");
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom + 50 >= Math.floor(window.innerHeight * 0.65)) {
      this.getReviewStructure();
    }
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("reviewstructure");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getPerformanceCycle();
        window.addEventListener("scroll", this.handleScroll);
        this.getReviewStructure();
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.MORE_OPTIONS,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getReviewStructure(isDelete = false) {
    if (CALLAPI) {
      if (this.state.offset < this.state.fullcount) {
        this.setState({ createmenu: false, selectedReview: null, isLoading:true }, () => {
          CALLAPI = false;
          instance
            .post(`perform/reviewstructure`, {
              isactive: true,
              isdraft: false,
              limit: 10,
              offset: this.state.offset,
            })
            .then((resp) => {
              CALLAPI = true;
              const list = resp.data.result.map((item) => {
                const value = { ...item };
                if (item.reviewperiodtypeid == 1) {
                  value.reviewperiod = "Monthly";
                } else if (item.reviewperiodtypeid == 2) {
                  value.reviewperiod = "Quarterly";
                } else if (item.reviewperiodtypeid == 3) {
                  value.reviewperiod = "Semi-Annually";
                } else if (item.reviewperiodtypeid == 4) {
                  value.reviewperiod = "Anually";
                } else if (item.reviewtypeid == 2) {
                  value.reviewperiod = "Manually";
                }
                return value;
              });
              const { listdata } = this.state;
              const data1 = isDelete ? list : [...listdata, ...list];

              this.setState(
                {
                  offset: this.state.offset + this.state.limit,
                  listdata: data1,
                  backuplistdata: data1,
                  data: true,
                  fullcount: resp.data.result[0] && resp.data.result[0].count,
                  isLoading:false 
                  // loading: false,
                },
                () => this.handleSort(this.state.orderBy),
              );
            });
        });
      }
    }
  }

  create() {
    return (
      !this.state.nofuel && (
        <Create
          {...this.props}
          {...this.state}
          tempdata={tempdata}
          onClosed={this.onClosed}
          getReviewStructure={this.getReviewStructure}
        />
      )
    );
  }

  async onCreate() {
    const selectedReview = {
      reviewstructureid: 0,
      structurename: null,
      reviewperiodtypeid: null,
      reviewtypeid: null,
      isformalwaysopen: true,
      formopentypeid: null,
      formclosetypeid: null,
      isdraft: false,
      participant: JSON.parse(tempdata),
      
    };
    this.setState(
      {
        selectedReview,
        createmenu: false,
      },
      () => {
        this.props.history.push(`${this.props.match.path}/create`);
      },
    );
  }

  onEdit() {
    const { selectedRow } = this.state;

    const tempparticipant1 = [
      {
        // feedbacksettingsid: 1,
        participantdayid: null,
        participanttypeid: 1,
        openday: null,
        frequencytypeid: null,
        closeday: null,
        isprimarymanager: false,
        issecondarymanager: false,
        ismanagersmanager: false,
        issecondarymanagerreportee: false,
        issharefeedback: false,
        isfeedbackanonymous: false,
        isviewduring: false,
        isviewafter: false,
        isSelected: false,
        isemppeerdecide:false,
      },
      {
        // feedbacksettingsid: 1,
        participantdayid: null,
        participanttypeid: 2,
        openday: null,
        frequencytypeid: null,
        closeday: null,
        isprimarymanager: true,
        issecondarymanager: false,
        ismanagersmanager: false,
        issecondarymanagerreportee: false,
        issharefeedback: false,
        isfeedbackanonymous: false,
        isviewduring: false,
        isviewafter: false,
        isSelected: false,
        isemppeerdecide:false,
      },
      {
        // feedbacksettingsid: 1,
        participantdayid: null,
        participanttypeid: 3,
        openday: null,
        frequencytypeid: null,
        closeday: null,
        isprimarymanager: false,
        issecondarymanager: false,
        ismanagersmanager: false,
        issecondarymanagerreportee: false,
        issharefeedback: false,
        isfeedbackanonymous: false,
        isviewduring: false,
        isviewafter: false,
        isSelected: false,
        isemppeerdecide:false,
      },
      {
        // feedbacksettingsid: 1,
        participantdayid: null,
        participanttypeid: 4,
        openday: null,
        frequencytypeid: null,
        closeday: null,
        isprimarymanager: false,
        issecondarymanager: false,
        ismanagersmanager: false,
        issecondarymanagerreportee: false,
        issharefeedback: false,
        isfeedbackanonymous: false,
        isviewduring: false,
        isviewafter: false,
        isSelected: false,
        isemppeerdecide:false,
      },
    ];

    instance
      .get(`/perform/getreviewstructure/${selectedRow.reviewstructureid}`)
      .then((resp) => {
        console.log(resp.data.result[0]);
        if (resp.data.result[0].participant != null) {
          const participant1 = resp.data.result[0].participant.filter(
            (x) => x.participanttypeid == 1,
          );
          const participant2 = resp.data.result[0].participant.filter(
            (x) => x.participanttypeid == 2,
          );
          const participant3 = resp.data.result[0].participant.filter(
            (x) => x.participanttypeid == 3,
          );
          const participant4 = resp.data.result[0].participant.filter(
            (x) => x.participanttypeid == 4,
          );
          if (participant1 && participant1.length > 0) {
            participant1[0].isSelected = true;
            tempparticipant1[0] = participant1[0];
          }
          if (participant2 && participant2.length > 0) {
            participant2[0].isSelected = true;
            tempparticipant1[1] = participant2[0];
          }
          if (participant3 && participant3.length > 0) {
            participant3[0].isSelected = true;
            tempparticipant1[2] = participant3[0];
          }
          if (participant4 && participant4.length > 0) {
            participant4[0].isSelected = true;
            tempparticipant1[3] = participant4[0];
          }
        }
        resp.data.result[0].participant = tempparticipant1;
        this.setState(
          { selectedReview: resp.data.result[0], createmenu: false },
          () => {
            this.props.history.push(`${this.props.match.url}/create`);
          },
        );
      });
  }

  onClosed() {
    this.setState(
      {
        selectedData: null,
        // listdata: [],
        offset: 0,
        fullcount: 1,
        // offset: 0,
      },
      () => {
        this.getReviewStructure(true);
        this.props.history.push(`${this.props.match.path}/list`);
      },
    );
  }

  onDelete() {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            const { selectedRow } = this.state;
            this.props.closeSnackbar();
            instance
              .get(
                `perform/deletereviewstructure/${
                  selectedRow ? selectedRow.reviewstructureid : ""
                }`,
              )
              .then(() => {
                this.props.enqueueSnackbar("Successfully deleted.", {
                  variant: "success",
                });
                this.setState(
                  {
                    selectedRow: null,
                    createmenu: false,
                    // listdata: [],
                    offset: 0,
                    totalcount: 1,
                    backupList: [],

                    data: [],
                  },
                  () => {
                    this.getReviewStructure(true);
                  },
                );
              })
              .catch((error) => {
                const msg =
                  error.response &&
                  error.response.data &&
                  error.response.data.error.message;
                this.props.enqueueSnackbar(msg || "", {
                  variant: "error",
                });
                this.setState({
                  createmenu: false,
                });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() =>
            this.setState({ createmenu: false }, () =>
              this.props.closeSnackbar(),
            )
          }
        >
          No
        </Button>,
      ],
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  __renderLinkedUser(event, row) {
    const data = {
      reviewstructureid: row.reviewstructureid,
      isactive: true,
      isdraft: false,
    };
    instance.post("perform/getreviewformlist", data).then((result) => {
      console.log(result);
      this.setState({
        linkeddetails: result.data.result,
        draweropen: true,
        drawer_anchorEl: event.currentTarget,
        selectedRow: row,
        isViewDetails: true,
        right: true,
      });
    });
    console.log(this.state.linkeddetails);
  }

  createNewMenuClose() {
    this.setState({ createmenu: false });
  }

  handleSort = (property) => {
    // console.log(property, event, 'onsort');
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    const listdata = this.stableSort(
      this.state.listdata,
      this.getSorting(order, orderBy),
    );
    this.setState({ order, orderBy, listdata });
  };

  stableSort(array = [], cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }

  desc(a, b, orderBy) {
    console.log("orderBy: ", orderBy);
    if (orderBy) {
      if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
        return -1;
      }
      if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
        return 1;
      }
      return 0;
    }
  }

  renderList() {
    const { isViewDetails, listdata, searchReviewValue } = this.state;
    return (
      // this.state.data && (
        <div className="content-outer-wrapper">
          <Grid container>
            <Grid item xs={12} md={2} sm={12}>
              <PageHeader header="Review structure" />
            </Grid>
            {(listdata.length > 0 || searchReviewValue) && (
              <Grid
                item
                xs={12}
                md={10}
                sm={12}
                justify="flex-end"
                className="display-flex"
                style={{ marginBottom: 16 }}
              >
                <span style={{ width: 240 }}>
                  <span
                    className="t-16"
                    style={{ color: "rgba(0,0,0,0.87)", marginRight: 4 }}
                  >
                    Sort By:
                  </span>
                  <Select
                    name="age"
                    displayEmpty
                    value={this.state.orderBy}
                    onChange={(e) => {
                      this.handleSort(e.target.value);
                    }}
                    className="text-color-grey select-sort width70"
                    variant="outlined"
                  >
                    <MenuItem className="sort-item" value={"sortableDate"}>
                      Created Date
                    </MenuItem>
                    {this.state.headers
                      .filter((x) => x.key != "edit" && x.key != "delete")
                      .map((header) => {
                        if (
                          header.key !== "imagepath" &&
                          header.key !== "noofform" &&
                          header.key !== "moreoptions"
                        ) {
                          return (
                            <MenuItem value={header.key}>
                              {get(header, "name", "-")}
                            </MenuItem>
                          ); // .props.defaultMessage
                        }
                        return null;
                      })}
                  </Select>
                </span>

                <span className="margin-right-8" style={{ width: 250 }}>
                  <SearchSq
                    placeholder="Search review structure"
                    value={this.state.searchReviewValue}
                    onChange={(e) => this.handleStructureSearch(e)}
                  />
                </span>
                {/* {(listdata.length > 0 || searchReviewValue) && */}
                {this.state.permissions.editable && (
                  <Button
                    variant="contained"
                    className="btn btn-primary-md-blue "
                    color="primary"
                    onClick={this.onCreate}
                  >
                    Create
                  </Button>
                )}
                {/* // } */}
              </Grid>
            )}
          </Grid>

          {this.state.isLoading ?
           <CustomLoader/>
          
      :    <div>
          {listdata.length > 0 ? (
            <Grid>
              <div onScroll={this.handleScroll}>
                <List
                  onCreate={this.onCreate}
                  list={this.state.listdata}
                  headers={this.state.headers}
                  permissions={this.state.permissions}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  __renderLinkedUser={(e, row) =>
                    this.__renderLinkedUser(e, row)
                  }
                  module="review structure"
                  showOnlyList
                  onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
                />
              </div>
            </Grid>
          ) : !searchReviewValue ? (
            <div>
              <CreateComp
                text="Create your first policy to get started"
                heading="There are no policies to display yet!"
                onCreate={this.onCreate}
                imageSrc={emptylist}
                permissions={this.state.permissions}
              />
            </div>
          ) : (
            <div
              style={{ height: "77vh" }}
              className="position-rel margin-top-16"
            >
              <DefaultComp
                //  text={this.getText()}
                heading={"There are no review forms!"}
                imageSrc={emp360}
              />
            </div>
          )}
          </div>
          }
          <Popover
            open={this.state.createmenu}
            anchorEl={this.state.create_anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            onClose={() => this.setState({ createmenu: false })}
            className="margin-top-8"
          >
            <Paper style={{ width: 190 }}>
              <div>
                <MenuListComponent>
                  <ListItem
                    className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                    onClick={this.onEdit}
                  >
                    <ListItemText style={{ padding: 0 }}>
                      <span className="small-dark-secondary">Edit</span>
                    </ListItemText>
                  </ListItem>
                  <ListItem
                    className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                    onClick={this.onDelete}
                  >
                    <ListItemText style={{ padding: 0 }}>
                      <span className="small-dark-secondary">Delete</span>
                    </ListItemText>
                  </ListItem>
                </MenuListComponent>
              </div>
            </Paper>
          </Popover>
          <Drawer
            anchor="right"
            open={this.state.right}
            onClose={() =>
              this.setState({
                right: false,
                draweropen: false,
                isViewDetails: false,
              })
            }
            // onClose={this.toggleDrawer("right", false)}
            classes={{
              paper: `${"width30"} planner-drawer padding15`,
            }}
          >
            <DrawerHeader
              header=" Linked review forms"
              isbackarrow={false}
              closeDrawer={() =>
                this.setState({
                  right: false,
                  draweropen: false,
                  isViewDetails: false,
                })
              }
            />
            {isViewDetails && (
              <div>
                <Table>
                  <div>
                    <TableHead className="inline-table width100">
                      <TableRow>
                        <TableCell
                          style={{
                            fontWeight: "bold",
                            color: "rgba(0,0,0,0.87)",
                            background: "#edf5fd",
                            padding: "4px 78px 4px 24px",
                          }}
                        >
                          Linked review forms Name
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="inline-table width100">
                      {this.state.linkeddetails.map((x) => (
                        <TableRow>
                          {/* <TableCell
                              className="cursor-pointer drawer-leave-name"
                              style={{ width: "52%" }}
                            >
                               <span>{x.displayname}</span>
                            </TableCell> */}
                          <TableCell className="hide-event">
                            <span>{x.displayname}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </div>
                </Table>
              </div>
            )}
          </Drawer>
        </div>
      // )
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.ReviewStructure.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <IntlProvider locale="en">
            <div>
              {/* {this.state.data && ( */}
                <div>
                  <div>
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this.renderList}
                      />
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this.create}
                      />
                      <Redirect from={`${match.path}`} to={`${match.path}`} />
                    </Switch>
                  </div>
                </div>
              {/* )} */}
            </div>
          </IntlProvider>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
  LEAVES_POLICY: state.LEAVES_POLICY,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ReviewStructure)),
);
